"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Jane = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const CardRenderItem_1 = require("../render/CardRenderItem");
const SelectCard_1 = require("../../inputs/SelectCard");
class Jane extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.JANE,
            cardType: CardType_1.CardType.LEADER,
            metadata: {
                cardNumber: 'L40',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br.br;
                    b.opgArrow().text('RESET X-1').cards(1).secondaryTag(CardRenderItem_1.AltSecondaryTag.BLUE).asterix();
                }),
                description: 'Once per game, mark up to X-1 blue card actions as unused this generation, where X is the current generation number.',
            },
        });
        this.isDisabled = false;
    }
    play() {
        return undefined;
    }
    canAct(player) {
        const usedActionCards = this.getUsedActionCards(player);
        return this.isDisabled === false && usedActionCards.length > 0 && player.game.generation > 1;
    }
    action(player) {
        const game = player.game;
        const resetCount = Math.min(game.generation - 1, this.getUsedActionCards(player).length);
        for (let i = 0; i < resetCount; i++) {
            game.defer(new DeferredAction_1.DeferredAction(player, () => new SelectCard_1.SelectCard('Select a blue card action to mark as unused', 'Select', this.getUsedActionCards(player), (selected) => {
                player.actionsThisGeneration.delete(selected[0].name);
                return undefined;
            })));
        }
        game.defer(new DeferredAction_1.DeferredAction(player, () => {
            this.isDisabled = true;
            return undefined;
        }));
        return undefined;
    }
    getUsedActionCards(player) {
        const result = [];
        for (const playedCard of player.playedCards) {
            if (playedCard.cardType === CardType_1.CardType.ACTIVE &&
                playedCard.action !== undefined &&
                playedCard.canAct !== undefined &&
                player.getActionsThisGeneration().has(playedCard.name)) {
                result.push(playedCard);
            }
        }
        return result;
    }
}
exports.Jane = Jane;
//# sourceMappingURL=Jane.js.map